import { render, staticRenderFns } from "./EmergingArtistCollection.vue?vue&type=template&id=380d5031&scoped=true&"
import script from "./EmergingArtistCollection.vue?vue&type=script&lang=js&"
export * from "./EmergingArtistCollection.vue?vue&type=script&lang=js&"
import style0 from "./EmergingArtistCollection.vue?vue&type=style&index=0&id=380d5031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d5031",
  null
  
)

export default component.exports